import { createContext } from "react"

export const SelectedBike = createContext(null)